import { memo } from 'react';
import { Card, Stub, VStack } from '@direct-frontend/components';
import { DashboardAlertStub } from '../DashboardAlert';
import styles from './DashboardAlertsWindow.module.css';

export const DashboardAlertsWindowStub = memo(function DashboardAlertsWindowStub() {
    return (
        <Card color="white" borderRadius="14" className={styles.wrapperCard}>
            <VStack className={styles.innerStub} gap="8" height="212px">
                <div className={styles.header}>
                    <Stub borderRadius="8" width={380} height={32} />
                </div>
                <DashboardAlertStub />
            </VStack>
        </Card>
    );
});
